import { debounce, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadSearchResults, resetSearchState } from "./search-bar.slice";
import './search-bar.css'
import { RootState } from "../../store";


const SearchBar = () => {
  const dispatch: any = useDispatch();
  const initialQuery = useSelector((state: RootState) => state.searchBar.query);
  const [searchValue, setSearchValue] = useState(initialQuery);

  const handleSearchChange = (e: any) => {
    setSearchValue(e.target.value);
  }

  const searchDebounced = useMemo(() => debounce(handleSearchChange, 500), []);

  useEffect(() => {
    if(searchValue) {
      dispatch(loadSearchResults(searchValue));
    } else {
      dispatch(resetSearchState());
    }
  }, [searchValue, dispatch]);

  return (
      <>
        <TextField label="TV Show Title" variant="filled" placeholder="search for TV show" defaultValue={searchValue} onChange={searchDebounced} className="input"/>
      </>
  );
}

export default SearchBar;